export * from "./TextAndImage";
